import { render, staticRenderFns } from "./StoreConfiguration.vue?vue&type=template&id=0c98c6f4&scoped=true"
import script from "./StoreConfiguration.vue?vue&type=script&lang=ts"
export * from "./StoreConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./StoreConfiguration.vue?vue&type=style&index=0&id=0c98c6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98c6f4",
  null
  
)

export default component.exports